import { Button, Card, Typography } from 'antd';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { CredCaseFileUploadButtonWithPreviewContainer } from './cred-case-file-upload-button-with-preview.container';
import { AzureBlobResponse } from '../../../../../shared/file-upload/azure-upload';
import { AdditionalFilesContainer } from './additional-files.container';
import { FileUploadWithGeneratePdfPacketButtonContainer } from './file-upload-with-generate-pdf-packet-button.container';
import { FileUploadWithGenerateVerificationFormButtonContainer } from './file-upload-with-generate-verification-form-button.container';
import { Helmet } from 'react-helmet';

interface FilesProps {
  shared?: boolean;
  caseId: string;
  isAssigned: boolean;
  onUploadSuccess: (response: AzureBlobResponse, fieldName: string) => Promise<void>;
  caseState: string;
  isCaseOrApplicant: string;
}

const { Title } = Typography;

export const Files: React.FC<FilesProps> = (props) => {
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    setIsEditing(false);
  }, [props.caseState]);

  const params = useParams();
  const disabled = !props.isAssigned || props.caseState === 'draft' || props.caseState === 'decisionRendered' || (props.caseState === 'revisionRequested' && props.isAssigned);

  const verificationPacketFiles: Map<string, string> = new Map();
  verificationPacketFiles.set('verificationForm', 'verification-form.pdf');
  verificationPacketFiles.set('credential', 'credential');
  verificationPacketFiles.set('translation', 'translation');
  verificationPacketFiles.set('verificationPacketResponse', 'verification-packet-response.pdf');
  verificationPacketFiles.set('redactedNotarizedIdForm', 'redacted-notarized-id-form.pdf');

  return (
    <>
      <Helmet>
        <title>{props?.isCaseOrApplicant} - Files</title>
      </Helmet>
      <Card
        hoverable
        style={{
          width: '100%',
          height: '70%',
          marginTop: 20
        }}
      >
        <div className="p-12">
          <div className="flex justify-between items-start">
            <div className="flex flex-col space-y-1">
              <Title level={5}>Private Files</Title>
              <p>(Not Visible to Applicant)</p>
            </div>

            <Button type="primary" disabled={disabled} onClick={() => setIsEditing((prev) => !prev)}>
              {isEditing ? 'Editing' : 'Edit'}
            </Button>
          </div>

          <div className="flex flex-col space-y-6 mt-6">
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                marginBottom: '20px'
              }}
            >
              <FileUploadWithGenerateVerificationFormButtonContainer
                title={'Verification Form'}
                caseId={props.caseId}
                fileName={'verification-form.pdf'}
                permittedContentTypes={['application/pdf']}
                permittedExtensions={['pdf']}
                isPreviewOnly={!isEditing}
                isShowFileName={false}
                setIsEditing={setIsEditing}
              />

              <FileUploadWithGeneratePdfPacketButtonContainer
                title="Verification Packet"
                caseId={props.caseId}
                verificationFileName="verification-packet.pdf"
                verificationFileNames={verificationPacketFiles}
                permittedContentTypes={['application/pdf']}
                permittedExtensions={['pdf']}
                isPreviewOnly={!isEditing}
                isUploadPreviewImage={false}
                isVerificationPacket={true}
                isShowFileName={false}
                setIsEditing={setIsEditing}
              />
              <div style={{ margin: '10px' }}>
                <CredCaseFileUploadButtonWithPreviewContainer
                  caseId={params.caseId ?? ''}
                  title="Verification Packet Response"
                  buttonText="Upload/Reupload"
                  permittedContentTypes={['application/pdf']}
                  permittedExtensions={['pdf']}
                  isPreviewOnly={!isEditing}
                  isShowFileName={false}
                  fileName="verification-packet-response.pdf"
                  fieldName="verificationPacketResponse"
                  setIsEditing={setIsEditing}
                  onUploadSuccess={(response: AzureBlobResponse) => {
                    props.onUploadSuccess(response, 'verificationPacketResponse');
                  }}
                />
              </div>

              <FileUploadWithGeneratePdfPacketButtonContainer
                title="Verification Component Packet"
                caseId={props.caseId}
                verificationFileName="verification-component-packet.pdf"
                verificationFileNames={verificationPacketFiles}
                permittedContentTypes={['application/pdf']}
                permittedExtensions={['pdf']}
                isPreviewOnly={!isEditing}
                isUploadPreviewImage={false}
                isVerificationPacket={false}
                isShowFileName={false}
                setIsEditing={setIsEditing}
              />
            </div>
            <AdditionalFilesContainer caseState={props.caseState} caseId={props.caseId} isCurrentAssigned={props.isAssigned} disabled={disabled} />
          </div>
        </div>
      </Card>
    </>
  );
};
